import React from "react";

function InformationIcon(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
            fill="currentColor"
            width={props.width || 48}
            height={props.height || 48}
            {...props}
        >
            <g>
                <path d="M256,156.3a59.3,59.3,0,0,1,59.3,59.3V452.8a59.3,59.3,0,0,1-118.6,0V215.6A59.3,59.3,0,0,1,256,156.3Z" />
                <circle
                    cx="59.3"
                    cy="59.3"
                    r="59.3"
                    transform="translate(196.7 0)"
                />
            </g>
        </svg>
    );
}

export default InformationIcon;
